/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationRecipient } from './NotificationRecipient';
import {
    NotificationRecipientFromJSON,
    NotificationRecipientFromJSONTyped,
    NotificationRecipientToJSON,
    NotificationRecipientToJSONTyped,
} from './NotificationRecipient';
import type { SourceContext } from './SourceContext';
import {
    SourceContextFromJSON,
    SourceContextFromJSONTyped,
    SourceContextToJSON,
    SourceContextToJSONTyped,
} from './SourceContext';

/**
 * Intent-based notification request; channel and delivery resolved by orchestration
 * @export
 * @interface NotifyRequest
 */
export interface NotifyRequest {
    /**
     * Notification category (e.g. boundary_change, escalation, case_created). Used for preference resolution.
     * @type {string}
     * @memberof NotifyRequest
     */
    category: string;
    /**
     * Recipients as identifiers (userId, email, or phone). System resolves to delivery targets.
     * @type {Array<NotificationRecipient>}
     * @memberof NotifyRequest
     */
    recipients: Array<NotificationRecipient>;
    /**
     * Template ID from EMAIL_TEMPLATES config. If provided with variables, subject/body resolved from template.
     * @type {string}
     * @memberof NotifyRequest
     */
    templateId?: string;
    /**
     * Variables for template substitution when templateId is used
     * @type {{ [key: string]: any; }}
     * @memberof NotifyRequest
     */
    variables?: { [key: string]: any; };
    /**
     * Subject (for email; optional for SMS)
     * @type {string}
     * @memberof NotifyRequest
     */
    subject?: string;
    /**
     * HTML body (email only)
     * @type {string}
     * @memberof NotifyRequest
     */
    bodyHtml?: string;
    /**
     * Plain text body (email or SMS)
     * @type {string}
     * @memberof NotifyRequest
     */
    bodyPlain?: string;
    /**
     * Source context for sensitivity/policy (resourceType, resourceId)
     * @type {SourceContext}
     * @memberof NotifyRequest
     */
    sourceContext?: SourceContext;
}

/**
 * Check if a given object implements the NotifyRequest interface.
 */
export function instanceOfNotifyRequest(value: object): value is NotifyRequest {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function NotifyRequestFromJSON(json: any): NotifyRequest {
    return NotifyRequestFromJSONTyped(json, false);
}

export function NotifyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotifyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'],
        'recipients': ((json['recipients'] as Array<any>).map(NotificationRecipientFromJSON)),
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'variables': json['variables'] == null ? undefined : json['variables'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'bodyPlain': json['bodyPlain'] == null ? undefined : json['bodyPlain'],
        'sourceContext': json['sourceContext'] == null ? undefined : SourceContextFromJSON(json['sourceContext']),
    };
}

export function NotifyRequestToJSON(json: any): NotifyRequest {
    return NotifyRequestToJSONTyped(json, false);
}

export function NotifyRequestToJSONTyped(value?: NotifyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'recipients': ((value['recipients'] as Array<any>).map(NotificationRecipientToJSON)),
        'templateId': value['templateId'],
        'variables': value['variables'],
        'subject': value['subject'],
        'bodyHtml': value['bodyHtml'],
        'bodyPlain': value['bodyPlain'],
        'sourceContext': SourceContextToJSON(value['sourceContext']),
    };
}

